<template>
  <div>
      <!-- M60 -->
    <div v-if="brand == 6" class="print-table-body__head" style="height: 10mm;">
      <div
        class="print-table-body__attr"
        v-for="(item, $index) in headConfig"
        :key="$index + 'td-1'"
        :class="item.cls"
      >
        <span v-if="!item.wrap">{{item.label}}</span>
        <div v-if="item.wrap">
          <div style="border-bottom: 1px solid #000;">{{item.italyColorLabel}}</div>
          <div>{{item.label}}</div>
        </div>
      </div>
      <div
        class="print-table-body__head__color"
        v-for="(item, $index) in italyColorList"
        :key="$index + 'td-2'"
      >
        <div style="border-bottom: 1px solid #000;">&nbsp;{{item.italyColorName}}</div>
        <div>{{item.colorName}}</div>
      </div>
    </div>
    <div v-if="brand != 6" class="print-table-body__head">
      <div
        class="print-table-body__attr"
        v-for="(item, $index) in headConfig"
        :key="$index + 'td-1'"
        :class="item.cls"
      >{{item.label}}</div>
      <div
        class="print-table-body__head__color"
        v-for="(item, $index) in colorList"
        :key="$index + 'td-2'"
        :style="item.style"
      >{{item.label}}</div>
    </div>
  </div>
</template>

<script>
import { JsonDeepCopy } from "src/store/utils";
import {
  titleRule,
  setWdith,
  tableHeadConfigACE,
  tableHeadConfigBD,
} from "./widthRule";

const key = {
  ACE: tableHeadConfigACE,
  BD: tableHeadConfigBD,
};
function resetList(list, type, length) {
  switch (type) {
    case 1:
      for (let i = 0; i < 4 - length; i++) {
        list.push({
          colorName: "",
          style: setWdith("8%"),
        });
      }
      break;
    case 2:
      for (let i = 0; i < 6 - length; i++) {
        list.push({
          colorName: "",
          style: setWdith("6%"),
        });
      }
      break;
    case 3:
      for (let i = 0; i < 4; i++) {
        list.push({
          colorName: i === 0 ? "通色" : "",
          style: setWdith("8%"),
        });
      }
      break;
  }
  return list;
}
// 判断那种显示类型
// 3 -> 没有
// 1 -> 1~4
// 2 -> 5~6
//新打印纸只支持1~4
function numRule(num) {
  if (num === 0) {
    return 3;
  } else if (num <= 4) {
    return 1;
  } else {
    return 2;
  }
}
export default {
  name: "table-body-head",
  props: {
    materialColorMapList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      defalut: "ACE",
    },
    italyColor: {
      type: Object,
      default: () => ({}),
    },
    brand:{
        default: "1"
    }
  },
  computed: {
    headConfig() {
      return key[this.type].map((item) => ({
        ...item,
        // class: setWdith(titleRule[this.type][item.type])
        cls: `${item.type}`,
      })).filter(_item => !_item.showBrand || _item.showBrand == this.brand);
    },
    colorList() {
      let list = JsonDeepCopy(this.materialColorMapList);
      const length = list.length;
      const type = numRule(length);
      const itemWidth = getItemwidth(length, key[this.type]);

      list = resetList(list, type, length);

      return list.map((item) => ({
        ...item,
        label: item.colorName,
      }));

      // 转换数据

      function getItemwidth(length, rule) {
        const total = rule.reduce((pre, next) => {
          return pre + next;
        }, 0);
      }
    },
    italyColorList() {
      if (this.materialColorMapList) {
        let list = JsonDeepCopy(this.materialColorMapList);
        const length = list.length;
        const type = numRule(length);
        list = resetList(list, type, length);
        return list;
      }
      return [];
    },
  },
  data() {
    return {};
  },
  mounted() {
    console.log('this.colorList', this.colorList)
  }
};
</script>
